module.exports = __webpack_public_path__ + "img/jpg-icon.9307682c.webp";